import o from "./index259.js";
import { createBlock as a, openBlock as r, resolveDynamicComponent as t, mergeProps as n, withCtx as l, createElementBlock as s, createCommentVNode as i, renderSlot as d } from "vue";
/* empty css         */
import m from "./index231.js";
const p = {
  key: 0,
  class: "font-bold text-text-l"
};
function f(e, b, u, g, c, h) {
  return r(), a(t(e.getTag()), n({
    class: ["flex items-center transition-colors duration-200 border border-solid ease-ms rounded-normal", {
      "px-16": e.hasDefaultSlot(),
      "active:translate-y-2 hover:bg-color-brand-beige-50 border-none underline": !e.isDisabled,
      "border-none disabled-text underline": e.isDisabled,
      "justify-center": !e.hasDefaultSlot() || e.isCentered,
      "text-center": e.isCentered,
      "h-52 min-w-52": !e.isSmall,
      "h-38 min-w-38": e.isSmall
    }],
    "data-component": e.$options.name,
    disabled: e.isDisabled,
    type: e.getType(),
    rel: e.getRel(),
    target: e.getTarget(),
    href: e.getHref(),
    "aria-label": e.ariaLabel
  }, e.tracking, { onClick: e.onClick }), {
    default: l(() => [
      e.hasDefaultSlot() ? (r(), s("span", p, [
        d(e.$slots, "default", {}, void 0, !0)
      ])) : i("", !0)
    ]),
    _: 3
  }, 16, ["class", "data-component", "disabled", "type", "rel", "target", "href", "aria-label", "onClick"]);
}
const S = /* @__PURE__ */ m(o, [["render", f], ["__scopeId", "data-v-3100b0ad"]]);
export {
  S as default
};
